<template>
    <div>
        {{currentStepName}}
        <slot/>
        <slot name="left-actions" v-if="canGoPreviousStep">
            <r-button @click="goPreviousStep">{{backLabel}}</r-button>
        </slot>
        <slot name="actions" v-if="canGoNextStep">
            <r-button @click="goNextStep">{{nextStepLabel}}</r-button>
        </slot>
    </div>
</template>

<script>
    export default {
        name: 'v-form-wizard',
        provide() {
            return {
                registerStep: this.registerStep,
                registerAction: this.registerAction,
                goPreviousStep: this.goPreviousStep,
                goNextStep: this.goNextStep,
                getContext: this.getContext,
            };
        },
        props: {
            backLabel: {
                type: String,
                default: 'Back',
            },
            skipLabel: {
                type: String,
                default: 'Skip',
            },
            nextLabel: {
                type: String,
                default: 'Next',
            },
            submitLabel: {
                type: String,
                default: 'Save',
            },
        },
        computed: {
            enabledSteps() {
                return this.steps.filter(step => !step.disabled);
            },
            maxIndex() {
                return this.enabledSteps && this.enabledSteps.length && (this.enabledSteps.length - 1);
            },
            isFirstStep() {
                return this.currentStepIndex === 0;
            },
            isLastStep() {
                return this.currentStepIndex === this.maxIndex;
            },
            canGoPreviousStep() {
                return !this.isFirstStep;
            },
            canGoNextStep() {
                return this.currentStep && !this.currentStep.isSelfManaged;
            },
            nextStepLabel() {
                if (this.currentStep && this.currentStep.nextStepLabel) {
                    return this.currentStep.nextStepLabel;
                }
                return this.isLastStep ? this.submitLabel : this.nextLabel;
            },
            currentStepName() {
                return this.currentStep && this.currentStep.stepName;
            },
            currentStep: {
                get() { return this.context.currentStep; },
                set(newValue) { this.context.currentStep = newValue; },
            },
            currentStepIndex: {
                get() { return this.context.currentStepIndex; },
                set(newValue) {
                    if (newValue > this.maxIndex || newValue < 0) {
                        return;
                    }
                    this.context.currentStepIndex = newValue;
                    this.currentStep = this.enabledSteps[newValue];
                },
            },
            formData: {
                get() { return this.context.formData; },
                set(newValue) { this.context.formData = newValue; },
            },
        },
        data() {
            return {
                steps: [],
                actions: {},
                context: {
                    currentStep: null,
                    currentStepIndex: -1,
                    formData: {},
                },
            };
        },
        methods: {
            registerStep(step) {
                const stepIndex = this.steps.findIndex(
                    currStep => currStep.stepKey === step.stepKey,
                );
                if (stepIndex > -1) {
                    this.steps.splice(stepIndex, 1, step);
                } else if (this.steps.push(step) === 1) {
                    this.currentStepIndex = 0;
                }
            },
            registerAction(stepKey, action) {
                this.actions[stepKey] = action;
            },
            getContext() {
                return this.context;
            },
            goPreviousStep() {
                this.$nextTick(() => {
                    this.currentStepIndex -= 1;
                });
            },
            goNextStep() {
                const action = this.actions[this.currentStep.stepKey];
                if (action && action.delegated) {
                    const outcome = action.delegated();
                    if (outcome !== undefined) {
                        this.formData[action.attributeName] = outcome;
                    } else if (!this.currentStep.optional) {
                        return;
                    }
                }
                if (this.isLastStep) {
                    this.$emit('submit', this.formData);
                } else {
                    this.$nextTick(() => {
                        this.currentStepIndex += 1;
                    });
                }
            },
        },
    };
</script>
